export default class PdpImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customizationList: this.props.idMaps
        };
    }
    getAllName() {
        let arrMap = [];
        this.state.customizationList.forEach((value, key) => {
            value.map(val => {
                arrMap.push(val.name);
            })
        });
        if (arrMap.length > 1) {
            var stickyValData = (arrMap.slice(0, 3));
            if (arrMap.length > 3) {
                let stickyVal = stickyValData.join(", ") + "...";
                return stickyVal
            }
            let stickyVal = stickyValData.join(", ");
            return stickyVal
        }

        else {
            return arrMap;
        }
    }
    getMoreLink() {
        let arrMap = [];
        this.state.customizationList.forEach((value, key) => { value.map(val => { arrMap.push(val.name); }) });
        if (arrMap.length > 3) {
            let moreLink = (arrMap.length - 3 + " More");
            return "+" + moreLink;
        }
    }
    getModalData() {
        let arrMap = [];
        this.state.customizationList.forEach((value, key) => { value.map(val => { arrMap.push(val.name); }) });
        var modalData = arrMap.join(", ");
        return modalData;
    }
    render() {
        const { ImageLarge, ImageAlt, Name, Price, BaseCalories, Description, MenuItemLabels, CalcPrice } = this.props.data;
        const { CategoryUrl, MenuUrl, MenuTitle, CategoryName, NutritionUrl, NutritionTitle } = this.props.breadcrumbData;

        return (
            <div className="ImagePdpWrapper" >
                <div className="container-fluid">
                    <div className="row pdp-hero">
                        <div className="imgWrapper">
                            <img className="pdpImage" src={ImageLarge} alt={ImageAlt} />
                        </div>
                        <a href={CategoryUrl} aria-labelledby="back" aria-label="Back to Category Link"><button aria-label="Back Button" aria-labelledby="back" type="button" className="btn btn-circle secondary pdpBack"><i className="o-icon o-icon--arrow-back-sec"></i></button></a>
                        <div className="imgDesc" data-theme="dark">
                            <p className="small-text menuLinkWrapper">
                                <a href={MenuUrl} className="menuLeftLink">{MenuTitle}</a>
                                /
                                <a href={CategoryUrl} className="menuRightLink">{CategoryName}</a>
                            </p>
                            <h1 className="ItemName showDesktop" tabindex="0">{Name}</h1>
                            <div id="imgTitle">
                                <h2 className="ItemName showMobile" tabindex="0">{Name}</h2>
                                <div className="stickyModifierElements d-none">
                                    <p className="selectedModifierList" id="selectedModifierList" tabindex="0">{this.getAllName()}</p>
                                    <a href="#" className="modifierModal" id="" tabindex="0" data-bs-target="#modifierModal" data-bs-toggle="modal">{this.getMoreLink()}</a>
                                </div>
                            </div>
                            <div className="modal fade" tabindex="-1" data-bs-backdrop="static" id="modifierModal">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                                <i className="o-icon-sm o-icon--close"></i>
                                            </button>
                                            <h4>Your Selections</h4>
                                        </div>
                                        <div class="modal-body">
                                            <p class="modifierItemsList">
                                                {this.getModalData()}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p>{(typeof MenuItemLabels !== 'undefined') ? (
                                MenuItemLabels.filter(labels => (labels.Code.toLowerCase() == "nychighsodium" || labels.Code.toLowerCase() == "phlsodiumwarning")).map(filteredLabel => (
                                    <img src={filteredLabel.Image} alt={filteredLabel.Name} data-code={filteredLabel.Code.toLowerCase()}
                                        className={filteredLabel.Code.toLowerCase()} />
                                ))
                            ) : null}</p>
                            {(Price != null && CalcPrice != "0.00" && BaseCalories != "") ?
                                <p className="priceWrapper"><span className="p1 bold price">{Price}</span><span className="calories">{BaseCalories} Cal </span></p> :
                                (Price != null && CalcPrice != "0.00" && BaseCalories == "") ?
                                    <p className="priceWrapper"><span className="p1 bold itemPrice" tabindex="0">{Price}</span></p> :
                                    ((Price == null ||  CalcPrice == "0.00" )&& BaseCalories != "") ?
                                        <p className="priceWrapper"><span className="p1 bold itemPrice" tabindex="0">{BaseCalories} Cal </span>
                                        </p> :
                                        ""
                            }
                            <p className="p1 desc showDesktop">{Description}</p>
                            <p className="p2 desc showTablet">{Description}</p>
                            <p className="p2 nutriLink">
                                <a href={NutritionUrl} target="_blank">{NutritionTitle}</a>
                            </p>
                            <i className="imageIcon"></i>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
